import { RestApi } from "infrontjs";

/**
 * Thin wrapper around IF.RestApi for talking to the BELTURO core-api.
 * Single global endpoint — no region logic (see config.json "api").
 */
export class Api
{
    constructor( app )
    {
        this.app = app;

        const apiUrl = this.app.config.get( 'api' );

        this._api = new RestApi(
            apiUrl,
            { "Content-Type": "application/json" }
        );
        this._api.headers.set( 'x-version', this.app.config.get( 'version' ) );
    }

    getUrl()
    {
        return this._api.url;
    }

    setSessionToken( sessionToken )
    {
        this._api.headers.set( 'x-sessiontoken', sessionToken );
    }

    deleteSessionToken()
    {
        this._api.headers.delete( 'x-sessiontoken' );
    }

    async get( endpoint, options = {} )
    {
        return this._processResult( await this._api.get( endpoint, null, options ) );
    }

    /**
     * @param {object} [options] IF.RestApi request options. `timeout` matters
     *        for the few endpoints that do real work while the operator waits
     *        (running an event import), where the 30 s default is too short.
     */
    async post( endpoint, params = {}, options = {} )
    {
        return this._processResult( await this._api.post( endpoint, params, null, options ) );
    }

    async delete( endpoint )
    {
        return this._processResult( await this._api.delete( endpoint ) );
    }

    async put( endpoint, params = {} )
    {
        return this._processResult( await this._api.put( endpoint, params ) );
    }

    async patch( endpoint, params = {} )
    {
        return this._processResult( await this._api.patch( endpoint, params ) );
    }

    _processResult( result )
    {
        if ( result && result.hasOwnProperty( 'status' ) )
        {
            console.log( result );
        }
        return result;
    }
}
